/**
 @ngdoc service
 @name mapScreeningcheckitemTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapScreeningcheckitemTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);


            tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('candidateName','candidateURI'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('noOfchecksRequired'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('owner'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('requester'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('requiredBy','date'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('noOfchecksLeft'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('percentageComplete'));
            tileFactory.addStatus(tileFactory.status.newStatus('screeningCheckStatus',
                // Positives
                [
                    tileFactory.LOOKUP_VALUE.SCREENING_CHECKITEM_OPEN,
                    tileFactory.LOOKUP_VALUE.SCREENING_CHECKITEM_CLOSED_SUCC
                ],
                // Negatives
                [
                    tileFactory.LOOKUP_VALUE.SCREENING_CHECKITEM_CLOSED_FAIL
                 ],
                // Warnings
                [
                    tileFactory.LOOKUP_VALUE.SCREENING_CHECKITEM_SUBCHECK_COMP
                ]

            ));
            return tileFactory.tileData;
        };

        return {
            map : map
        };
    };

    mapScreeningcheckitemTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapScreeningcheckitemTileService', mapScreeningcheckitemTileService);

}());